// extracted by mini-css-extract-plugin
module.exports = {"root":"PromoBannerEyebrow_root___jevG","countdown":"PromoBannerEyebrow_countdown__2QWau","icon":"PromoBannerEyebrow_icon__MXuCz"};